// Artificial order states for the hedge order monitor staging grid
export const ORDER_STATE_STAGING: string = "Staging";
export const ORDER_STATE_ERROR: string = "ERROR";
export const ORDER_STATE_REJECTED: string = "Rejected";
export const ORDER_STATE_SUBMITTED: string = "Processing ...";

// COLUMN DATA NAMES
export const COLUMN_SELECTION_DATA: string = "selection";
export const COLUMN_ACCOUNT_NAME: string = "accountName";
export const COLUMN_ACCOUNT_ID: string = "accountCode";
export const COLUMN_TRADE_DESK_ID: string = "traderGroupId"; // Trader Group
export const COLUMN_INTER_DESK_ID: string = "traderGroupId";
export const COLUMN_CCY_PAIR_CODE: string = "currencyPair";
export const COLUMN_TRADE_ORDER_TYPE_DATA: string = "requestedOrderType";
export const COLUMN_ALGO_PARAMETERS: string = "algoParameters";
export const COLUMN_START_TIME: string = "startTime";
export const COLUMN_END_TIME: string = "endTime";
export const COLUMN_PRIVATE_COMMENT: string = "comment2";
export const BMARK_DEFAULT_NAME = "BM";

const DEFAULT_CELL_CLASS: string = "ag-cell-default";

export const EDITOR_AMOUNT: string = "amountEditor";
export const EDITOR_AUTO_COMPLETE: string = "autoCompleteEditor";
export const EDITOR_TIME: string = "timeEditor";
export const COMMENT_EDITOR: string = "commentEditor";
